import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import CommonModal from '../../atoms/modal/CommonModal'
import ButtonCustom from '../../atoms/button/ButtonCustom'
import TextArea from '../../atoms/textarea/TextArea'
import { toastHelper } from '../../../util/toastHelper'
import { updateProposal } from '../../../features/proposalSlice'

function Reject({ clickHandler, data }) {
	const dispatch = useDispatch()
	const navigate = useNavigate()
	const [reason, setReason] = useState('')

	const handleRemove = () => {
		if (!reason) {
			return toastHelper('Please enter reason', 'error')
		}
		dispatch(
			updateProposal({
				proposalId: data,
				status: 'Rejected',
				reason: reason,
			})
		)
			.then(() => {
				navigate('/vendor-proposal')
				clickHandler()
			})
			.catch((error) => toastHelper(error.message, 'error'))
	}

	return (
		<CommonModal
			open={true}
			handleClose={clickHandler}
			heading={'Reject'}
			footerContent={
				<>
					<ButtonCustom
						variant="outlined"
						type="button"
						size="lg"
						onClick={clickHandler}
					>
						Cancel
					</ButtonCustom>
					<ButtonCustom
						variant="destructive"
						size="lg"
						onClick={handleRemove}
						disabled={!reason}
					>
						Reject
					</ButtonCustom>
				</>
			}
		>
			<label
				htmlFor="reason"
				style={{
					font: 'var(--body-font-three)',
					color: 'var(--secondary-Text)',
					display: 'block',
					marginBottom: '8px',
				}}
			>
				Reason *
			</label>
			<TextArea
				id="reason"
				name="reason"
				placeholder="Write reason"
				value={reason}
				onChange={(e) => setReason(e.target.value)}
			/>
		</CommonModal>
	)
}

export default Reject
